/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { TextboxInput } from '@blend/enterprise-components';
import { WrappedInput } from 'blb-components/WrappedInput';
export const messageInputConfig = {
  component: WrappedInput,
  customComponentProps: {
    placeholder: 'Type your message here...',
    rows: 5,
    type: 'text'
  },
  hideLabel: true,
  inputComponent: TextboxInput,
  label: '',
  name: 'message',
  validate: value => {
    return !!value && value.length > 1024 * 3 ? 'Please keep the message less than 3072 characters' : undefined;
  }
};